export default __webpack_public_path__ + "static/media/clearsky.b1d598e0.jpg";